/* eslint-disable class-methods-use-this, no-use-before-define, no-param-reassign, prefer-destructuring */
class Numbers {
  constructor() {
    this.numbers = document.getElementsByClassName("numbers")[0];
    if (this.numbers) {
      this.init();
    }
  }

  init() {
    function resetNumbers() {
      const factsSections = document.getElementsByClassName("numbers");
      Array.prototype.forEach.call(factsSections, (factsSection) => {
        const factsListItems = factsSection.getElementsByClassName(
          "js-numbers-list-item"
        );
        for (let i = 0; i < factsListItems.length; i += 1) {
          const factsListItemNumber = factsListItems
            .item(i)
            .getElementsByClassName("js-numbers-number")[0];
          factsListItemNumber.getElementsByTagName("span")[0].innerHTML = 0;
        }
      });
    }

    function startNumbersAnimation() {
      const factsSections = document.getElementsByClassName("numbers");
      const numbersPie = document.querySelector(".numbers__list__wrapper");

      function getRandomArbitrary(min, max) {
        return Math.random() * (max - min) + min;
      }

      function numbersAnimation(elem, endNumber) {
        numbersPie.classList.add("animaPie");
        const arrPie = document.querySelectorAll(".numbers__list-item");

        arrPie.forEach((node) => {
          node.classList.add("animaPieNumber");
        });

        let number = 0;
        const randomNumber = getRandomArbitrary(1, 10);
        let acceleration = endNumber / 20 + randomNumber;

        if (acceleration < 1) {
          acceleration = 1;
        }

        function frame() {
          if (number + acceleration > endNumber) {
            number = endNumber;
          } else {
            number += acceleration;
          }
          /* show frame */
          elem.innerHTML =
            // Math.floor(number); /* eslint-disable no-param-reassign */
            new Intl.NumberFormat("de-DE").format(Math.floor(number));
          if (number >= endNumber) {
            clearInterval(id);
          } // check finish condition
        }
        const id = setInterval(frame, 70); // draw every 1ms
      }

      Array.prototype.forEach.call(factsSections, (factsSection) => {
        if (factsSection.classList.contains("animated")) {
          const factsListItems = factsSection.getElementsByClassName(
            "js-numbers-list-item"
          );

          for (let i = 0; i < factsListItems.length; i += 1) {
            const factsListItemNumber = factsListItems
              .item(i)
              .getElementsByClassName("js-numbers-number")[0];
            const dataCount = factsListItemNumber.dataset.count;
            const dataAnimation = factsListItemNumber.dataset.animation;

            if (dataAnimation === "false") {
              numbersAnimation(
                factsListItemNumber.getElementsByTagName("span")[0],
                dataCount
              );
              factsListItemNumber.dataset.animation = "true";
            }
          }
        }
      });
    }

    resetNumbers();
    window.addEventListener("scroll", startNumbersAnimation);
  }
}

export default Numbers;
